export default {
  'purchaseOrder.home': 'home',
  'purchaseOrder.login': 'login',
  'purchaseOrder.register': 'register',
  'purchaseOrder.register.result': 'registerResult',
  'purchaseOrder.dashboard': 'dashboard',
  'purchaseOrder.dashboard.analysis': 'dashboardAnalysis',
};
